import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from '@material-ui/core/Tooltip';
import { InputLabel, Select, MenuItem } from '@material-ui/core';
import { green, pink } from '@material-ui/core/colors';

import React from "react";
import { mdiSim } from '@mdi/js'; import Icon from '@mdi/react';

const SIMDialog = ({ vehicle, OnSIMStatus }) => {
	const [open, setOpen] = React.useState(false);
	const [simStatus, setSimStatus] = React.useState();

	const handleClickOpen = () => {
		setOpen(true);
	};

	const handleClose = () => {
		setOpen(false);
	};

	const handlesimstatus = () => {
		setOpen(false);
		OnSIMStatus({ _id: vehicle._id, state: simStatus });
	}


	return (
		<>
			<Tooltip title='Activate/Deactivate DATA'>
				<IconButton aria-label="delete" onClick={handleClickOpen}
					size='small'
				>
					<Icon path={mdiSim} size={1} color={vehicle.tracker?.sim?.status === 'ACTIVATED' ? green[500] : pink["A400"]} />
				</IconButton>
			</Tooltip>
			<Dialog
				open={open}
				onClose={handleClose}
				aria-labelledby="alert-dialog-title"
				aria-describedby="alert-dialog-description"
			>
				<DialogTitle id="alert-dialog-title">
					{`Change SIM status: ${vehicle.type} - ${vehicle.registration_number} - ${vehicle.registration_state}?`}
				</DialogTitle>
				<DialogContent>
					<div style={{ display: 'flex', flexDirection: 'column', width: '400px' }}>
						<InputLabel id="demo-simple-select-label">SIM Status</InputLabel>
						<Select
							labelId="demo-simple-select-label"
							id="demo-simple-select"
							value={simStatus}
							onChange={e => setSimStatus(e.target.value)}
						>
							<MenuItem value={true}>Activate</MenuItem>
							<MenuItem value={false}>De-activate</MenuItem>
						</Select>
					</div>
				</DialogContent>
				<DialogActions>
					<Button onClick={handleClose} color="primary">
						Cancel
					</Button>
					<Button onClick={handlesimstatus} color="primary">
						Confirm
					</Button>
				</DialogActions>
			</Dialog>
		</>
	);
};

export default SIMDialog;
